import {HybirdBridge} from "@hybird/core/bridge/hybirdBridge";
import {FlutterConnectUsbDevice} from "@hybird/flutter/bridge/usbDevice";
import {Buffer} from "buffer";
import {crc16} from "@hybird/core/crc16";

class FlutterInfrared extends HybirdBridge {

  constructor() {
    super();
    HybirdBridge.prototype.infrared = new FlutterInfraredConnectUsbDevice()
    console.log(crc16("123456").toLowerCase());
  }
}

class FlutterInfraredConnectUsbDevice extends FlutterConnectUsbDevice {
  constructor() {
    super();
  }

  _hasDevice = false;
  _count = 0;

  get hasDevice() {
    return this._hasDevice;
  }

  _config = {
    number: "",
    crc16: "",
    name: "红外设备",
    baudRate: 600,
    dataBits: 8,
    flowControl: 'none',
    parity: 'none',
    stopBits: 1,
    onUsbDeviceValueChange: this._onUsbDeviceValueChange.bind(this),
    onUsbDeviceStateChange: undefined,
    onCheckDevice: undefined,
    vid: 6790,
    pid: 29987
  }

  set number(number) {
    this._config.number = number;
    this._config.crc16 = crc16(number).toLowerCase();
  }

  _send(hasDevice, force = false) {
    if (hasDevice) {
      this._count = 0;
    } else if (!hasDevice && this._count < 3 && !force) {
      this._count++;
      return;
    }

    if (hasDevice !== this._hasDevice) {
      this._hasDevice = hasDevice;
      console.log("onCheckDevice", this._context, this._config.crc16);
    }

    this._config.onCheckDevice?.(hasDevice);
  }

  _onUsbDeviceValueChange(event) {
    const value = Buffer.from(event.value, "hex").toString();
    this._lastMessage = new Date().getTime();

    let hasDevice = false;
    console.log("test", value, this._context);

    if (event.value === "00") {
      this._context = this._context.trim();

      if (this._context && this._context.length > 0) {
        if (getSimilarity(this._context, this._config.crc16) >= 75) {
          hasDevice = true;
        }

        this._send(hasDevice);
      }

      if (hasDevice) {
        //定时200ms未接收到数据, 则表示超出范围
        clearTimeout(this._timeout);
      }

      this._context = "";
    } else {
      this._context += value;
    }
  }

  async connectUsbDevice(config = {}) {
    return super.connectUsbDevice(config).then((data) => {
      if (this._outDeviceMonitor) {
        clearInterval(this._outDeviceMonitor);
      }

      this._outDeviceMonitor = setInterval(() => {
        const time = new Date().getTime() - this._lastMessage;
        if (time > 400) {
          console.info("超时未检测到设备，移出设备");
          this._send(false, true);
        }
      }, 500);
      return data;
    });
  }

  async disconnectUsbDevice() {
    if (this._outDeviceMonitor) {
      clearInterval(this._outDeviceMonitor);
      this._outDeviceMonitor = null;
    }

    return super.disconnectUsbDevice().then((data) => {
      return data;
    });
  }
}

/**
 * 获取2个字符串的相似度
 * @param {string} str1 字符串1
 * @param {string} str2 字符串2
 * @returns {number} 相似度
 */
function getSimilarity(str1, str2) {
  console.info("检测到设备", str1, str2);
  let sameNum = 0
  let index = 0;
  //寻找相同字符
  for (let i = 0; i < str1.length; i++) {
    for (let j = index; j < str2.length; j++) {
      if (str1[i] === str2[j]) {
        index = j;
        sameNum++
        break
      }
    }
  }

  // console.log(str1,str2);
  // console.log("相似度",(sameNum/str1.length) * 100);
  //判断2个字符串哪个长度比较长
  let length = str1.length
  return (sameNum / length) * 100 || 0
}

export const flutterInfrared = new FlutterInfrared();